import {createContext, useContext} from "react";
import {Translator, TranslatorFactory} from "../../translate";

type TranslationContextType = {
    translate: Translator,
    getTranslator: TranslatorFactory,
    language: string,
    setLanguage: (newLanguage: string) => Promise<void> | void,
}

export const TranslationContext = createContext<TranslationContextType>(null);

export function useTranslationContext() {
    return useContext(TranslationContext);
}
